import type { PropsUseSetTrackEvent } from '@carboncopyco/types/hooks';
import { injectScript } from '../../helpers/dom';

export type UseHubspot = {
  init: () => void;
  setContentType: (contentType: string) => void;
  setPathPageView: (path: string) => void;
  setTrackPageView: () => void;
  setIdentity: (
    email: string,
    customPropertities?: Record<string, unknown>
  ) => void;
  setTrackEvent: ({ eventId, value }: PropsUseSetTrackEvent) => void;
};

export const useHubspot = (): UseHubspot => {
  const _hsq = typeof window !== 'undefined' && window._hsq ? window._hsq : [];

  const setContentType = (contentType: string): void => {
    _hsq.push(['setContentType', contentType]);
  };

  const setTrackPageView = () => {
    _hsq.push(['trackPageView']);
  };

  const setPathPageView = (path: string): void => {
    _hsq.push(['setPath', path]);
    setTrackPageView();
  };

  const setIdentity = (
    email: string,
    customPropertities?: Record<string, unknown>
  ) => {
    _hsq.push([
      'identify',
      {
        email,
        ...customPropertities,
      },
    ]);
  };

  const setTrackEvent = ({ eventId, value }: PropsUseSetTrackEvent) => {
    _hsq.push([
      'trackEvent',
      {
        id: eventId,
        value,
      },
    ]);
  };
  function init() {
    injectScript({
      src: 'https://js.hs-scripts.com/20453961.js',
      id: 'hs-script-loader',
      async: true,
      defer: true,
    });
  }
  return {
    init,
    setContentType,
    setPathPageView,
    setTrackPageView,
    setIdentity,
    setTrackEvent,
  };
};
